import { queryOptions, skipToken } from '@tanstack/react-query'
import { keys } from './keys'
import {
  fetchCurrentAdminRbacPermissions,
  fetchRbacRole,
  fetchRbacRoles,
  fetchRbacRolesWithoutHolder,
} from './rbac.queries'

export const getRbacRolesOptions = () =>
  queryOptions({
    queryKey: keys.rbac.roles.list(),
    queryFn: fetchRbacRoles,
  })

export const getRbacRolesWithoutHolderOptions = () =>
  queryOptions({
    queryKey: keys.rbac.roles.withoutHolder(),
    queryFn: fetchRbacRolesWithoutHolder,
  })

/**
 * Autorisations de l'admin connecté, rangées sous SON identifiant : le jeton décide de la réponse,
 * mais un autre compte connecté ensuite ne relit jamais ce cache. Sans identifiant, rien n'est lu.
 */
export const getCurrentAdminRbacPermissionsOptions = (adminId: number | undefined) =>
  queryOptions({
    queryKey: keys.rbac.permissions.currentOf(adminId),
    queryFn: adminId !== undefined ? fetchCurrentAdminRbacPermissions : skipToken,
  })

export const getRbacRoleOptions = (roleId: number | undefined) =>
  queryOptions({
    queryKey: keys.rbac.roles.byId(roleId),
    queryFn: roleId !== undefined ? () => fetchRbacRole(roleId) : skipToken,
  })
